import {reactErrorHandler} from '@sentry/react'
import {createRouter, RouterProvider} from '@tanstack/react-router'
import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'

import {ClientErrorFallback} from './error-boundary/client-error-fallback'
import {initSentry} from './instrument'
import UmamiScript from './lib/umami'
import {stringifySearch} from './router-search'
import {routeTree} from './routeTree.gen'

import '@mantine/core/styles.css'
import '@mantine/dates/styles.css'
import '@mantine/notifications/styles.css'
import 'mantine-datatable/styles.css'
import './theme/fonts.css'

const router = createRouter({
    routeTree,
    stringifySearch,
    defaultErrorComponent: ClientErrorFallback,
})

initSentry(router)

declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router
    }
}

createRoot(document.getElementById('root')!, {
    onUncaughtError: reactErrorHandler(),
    onCaughtError: reactErrorHandler(),
    onRecoverableError: reactErrorHandler(),
}).render(
    <StrictMode>
        <RouterProvider router={router} />
        {import.meta.env.PROD && <UmamiScript websiteId="8870b613-c351-4af2-94ec-c3087f1c5169" />}
    </StrictMode>,
)
